export default __webpack_public_path__ + "static/logo-a8247f243134f5fabdec6323ff9e0efa.svg";